import { BeRow, BeStack, BeStrut, BeTabView, BeWindow } from "@beos-css/react/index.ts";
import { useState } from "react";

export function TabViewDemo() {
	const [tab, setTab] = useState("general");

	return (
		<section id="demo-tab-view">
			<h2>Tab view (BTabView)</h2>
			<p>Rounded beveled tabs; the selected tab merges into the content box (its segment of the top border is left open).</p>
			<BeRow wrap gap="row">
				<BeTabView
					tabs={[
						{ id: "general", label: "General" },
						{ id: "advanced", label: "Advanced" },
						{ id: "about", label: "About" },
					]}
					selected={tab}
					onSelect={setTab}
				>
					<div className="demo-tab-panel">
						{tab === "general" && "General settings panel."}
						{tab === "advanced" && "Advanced settings panel."}
						{tab === "about" && "About this application."}
					</div>
				</BeTabView>
			</BeRow>

			<p>
				<code>fitAll</code> — tabs stretch to fill the content width.
			</p>
			<div className="demo-wide">
				<BeTabView
					fitAll
					tabs={[
						{ id: "one", label: "One" },
						{ id: "two", label: "Two" },
						{ id: "three", label: "Three" },
					]}
				>
					<BeStack gap="item">
						Tabs share the full width.
						<BeStrut size={30} />
					</BeStack>
				</BeTabView>
			</div>

			<p>
				<code>multiLine</code> — tabs wrap onto stacked rows when they overflow (like 98.css multirows).
			</p>
			<BeWindow flush title="Preferences" onClose={() => {}} onZoom={() => {}} className="demo-tab-window">
				<BeStrut size={5} />
				<BeTabView
					multiLine
					tabs={[
						{ id: "files", label: "File Management" },
						{ id: "sharing", label: "Network Sharing" },
						{ id: "security", label: "Security & Privacy" },
						{ id: "quota", label: "Disk Quotas" },
						{ id: "sessions", label: "Active Sessions" },
						{ id: "logging", label: "System Logging" },
					]}
				>
					<BeStack gap="item">
						Resize the window to reflow rows.
						<BeStrut size={30} />
					</BeStack>
				</BeTabView>
			</BeWindow>
		</section>
	);
}
